import removeFilters from '@src/main/assets/icons/filter-clear-red.svg';
import xls from '@src/main/assets/icons/xls-red.svg';
import { Button } from 'primereact/button';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './IncidentTableHeader.module.scss';

interface Props {
  onRefresh: () => void;
  onClearFilters: () => void;
  onExportExcel?: () => void;
  showExportButtons?: boolean;
}

const IncidentTableHeader: FC<Props> = ({
  onRefresh,
  onClearFilters,
  onExportExcel,
  showExportButtons = true,
}) => {
  const { t } = useTranslation();

  return (
    <div className={`${styles['button-container']} mailbox-header-buttons`}>
      <Button
        icon="pi pi-refresh"
        tooltip={t('common.refresh')}
        onClick={onRefresh}
        tooltipOptions={{ position: 'bottom' }}
      />
      <Button
        type="button"
        tooltip={t('common.clearFilters')}
        icon={<img src={removeFilters} alt={t('common.clearFilters')} width="20" />}
        outlined
        onClick={onClearFilters}
        className="custom-button"
        tooltipOptions={{ position: 'bottom' }}
      />
      {showExportButtons && (
        <div className={styles['right-group']}>
          {onExportExcel && (
            <Button
              type="button"
              tooltip={t('common.excel')}
              icon={<img src={xls} alt={t('common.excel')} width="20" />}
              outlined
              onClick={onExportExcel}
              className={styles['custom-button']}
              tooltipOptions={{ position: 'bottom' }}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default IncidentTableHeader;
